var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section__subsection_blue section__company-nav"},[_c('div',{staticClass:"section__subsection-wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }